import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Package, PackageHost } from '../../Container';
import { alert, sendAlert } from './AlertCommands';
import { AlertHub } from './AlertHub';
import { AlertManager } from './AlertManager';

export class AlertPackage implements Package {

    public install = (host: PackageHost) => host
        .register(AlertManager, 'singleton')
        .register(AlertHub, 'singleton')
        .plug(inCommands(alert, sendAlert))
        .start(AlertHub);
}
